import React from 'react';

const BsModal = ({ show, onClose, title, children, footer, size = '' }) => {
    return (
        <>
            {/* Modal */}
            {show && (
                <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
                    <div className={`modal-dialog modal-dialog-centered ${size}`}>
                        <div className="modal-content">
                            {title && <div className="modal-header">
                                <h5 className="modal-title">{title}</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={onClose}
                                ></button>
                            </div>}
                            <div className="modal-body overflow-auto" style={{maxHeight: '60vh'}}>{children}</div>
                            {footer && (
                                <div className="modal-footer">
                                    {footer}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Backdrop */}
            {show && <div className="modal-backdrop fade show" style={{backgroundColor: 'rgba(16,19,41,.35)'}}></div>}
        </>
    );
};

export default BsModal;
